
<!-- [navbarBrandFull]="{src: 'assets/img/brand/logo.svg', width: 100, height: 45, alt: 'EKS-Ref-Arch Logo'}" -->
<div *ngIf="router.url !== '/' && router.url !== '/signup'">

<app-header 
  [fixed]="true"
  [navbarBrandFull]="{src: 'assets/img/brand/logo.png', height: 30, alt: 'Robo-Advisor Logo'}"
  [navbarBrandMinimized]="{src: 'assets/img/brand/logo.png', height: 30, alt: 'Robo-Advisor Logo'}"
  [sidebarToggler]="false"
  [asideMenuToggler]="false"
  [mobileAsideMenuToggler]="false"
  >
  
    <!-- Dropdown Menu -->
    <ul class="nav navbar-nav ml-auto">
    <li class="nav-item dropdown" dropdown placement="bottom right">

      <a class="nav-link" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle (click)="false">
        <i class="icon-user icons"></i>&nbsp;&nbsp;
      </a>

      <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
        <div class="dropdown-header text-center"><strong >Bonjour {{email$}}</strong></div>
        <div *ngIf="neversubscribed==false || role=='admin'">
        <a (click)="Gotoprofile()" class="dropdown-item" ><i class="fa fa-gear"></i>Paramétres</a>
      </div>
      <div *ngIf="neversubscribed==false || role=='admin'">
        <a (click)="GotoprofileSecurity()" class="dropdown-item" ><i class="fa fa-lock"></i>Sécurité</a>
      </div>
      <div *ngIf="role=='Client' ">
        <a (click)="GotoSupport()" class="dropdown-item" ><i class="fa fa-question-circle"></i>Support</a>
      </div>
        <div *ngIf="neversubscribed==false ">
        <a (click)="GotoAbonnement()" class="dropdown-item" ><i class="fa fa-id-card "></i>Mon Abonnement</a>
      </div>
      <div>
        <a (click)="logout(mymodal)" class="dropdown-item" ><i class="fa fa-sign-out"></i>Se déconnecter</a>
      </div>

        <!-- model start here  -->
        <ng-template #mymodal let-modal>
          <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title" style="color:#6600ff; font-weight: bold; font-size: 18px;">DÉCONNEXION</h4>
            <button type="button" class="close"    aria-label="Close" (click)="modal.dismiss('Cross click')">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body" style="font-size: 16px;">
            Êtes-vous sûr de quitter Robo Advisor ?
           </div>
          <div class="modal-footer">
           
            <button type="button" class="btn modele2" data-dismiss="modal" (click)="modal.dismiss('Cross click')" >Fermer</button>
            <button type="button" class="btn  modele" data-dismiss="modal" (click)="modal.close('Save click'); signout();">Confirmer</button>
            <!-- <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Ok</button> -->
          </div>
        </ng-template>
        <!-- model End here  -->

        <!-- <ng-template >
          <a class="dropdown-item"  [routerLink]="['/']" routerLinkActive="router-link-active"><i class="fa fa-unlock"></i>Se connecter</a>
        </ng-template> -->
        <!-- <a class="dropdown-item"><i class="fa fa-user"></i>Mon profil</a>
        <a class="dropdown-item" [routerLink]="['/auth/info']" routerLinkActive="router-link-active" ><i class="fa fa-wrench"></i>Auth Debug</a> -->
      </div>
      
    </li>
  </ul>
 
</app-header>
<div class="app-body">
  <div *ngIf="neversubscribed==false  || role=='admin'">
  <app-sidebar #appSidebar  [fixed]="true" [display]="'lg'" [minimized]="sidebarMinimized" (minimizedChange)="toggleMinimize($event)">
    <div *ngIf=" role==='Client' ">
    <app-sidebar-nav class ="navsd" [navItems]="navItems" [perfectScrollbar] [disabled]="appSidebar.minimized"></app-sidebar-nav>
  </div>
  <div *ngIf=" role==='admin' ">
  <app-sidebar-nav class ="navsd" [navItems]="navAdmin" [perfectScrollbar] [disabled]="appSidebar.minimized"></app-sidebar-nav>
  </div>  
  <app-sidebar-nav class="navweb" [navItems]="navMobItems" [perfectScrollbar] [disabled]="appSidebar.minimized"></app-sidebar-nav>
    
    

  
     
    <!-- <app-sidebar-minimizer></app-sidebar-minimizer> -->
  </app-sidebar>
</div>
  <!-- Main content -->
  <main class="main">
    <!-- Breadcrumb -->
    <!-- breaking change 'cui-breadcrumb' -->
    <!-- 
    <cui-breadcrumb></cui-breadcrumb>
    -->
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div><!-- /.container-fluid -->
  </main>
</div>
</div>
<app-footer>
  <span><b>Robo-Advisor</b> (Beta version)</span>
  <span class="ml-auto">Made with ♥ by <a target="_blank" href="https://linkedin.com/company/deepera">Deepera.AI</a> &copy; 2022</span>
</app-footer>

